import { MatrixEvent } from "matrix-js-sdk";
import { ROOM_MESSAGE } from "src/constants/matrixEventTypes";

export type MeetingCallNote = {
    id: string;
    callId: string;
    body: string;
    authorName: string;
    authorUserId: string;
    createdAt: number;
    matrixRoomId: string;
    referenceEventId: string;
};

export type MeetingNoteContent = {
    msgtype: "m.text";
    body: string;
    "m.new_content"?: MeetingNoteContent;
    "m.relates_to"?: {
        rel_type: "m.replace";
        event_id: string;
    };
};

declare module "matrix-js-sdk" {
    interface TimelineEvents {
        "m.room.message": MeetingNoteContent;
    }
}

export const MEETING_NOTE_EVENT_TYPE = ROOM_MESSAGE as "m.room.message";

export const createMeetingNoteContent = (body: string): MeetingNoteContent => ({
    msgtype: "m.text",
    body
});

export const parseMeetingCallNote = (event: MatrixEvent, roomId: string): MeetingCallNote | null => {
    if (event.getType() !== ROOM_MESSAGE || event.getRoomId() !== roomId) {
        return null;
    }
    const content = event.getContent<MeetingNoteContent>();
    if (content["m.relates_to"]?.rel_type === "m.replace") {
        return null;
    }
    const body = content.msgtype === "m.text" && typeof content.body === "string"
        ? content.body.trim()
        : "";
    if (!body) {
        return null;
    }

    return {
        id: event.getTxnId() || event.getId() || `${roomId}-${event.getTs()}`,
        callId: roomId,
        body,
        authorName: "",
        authorUserId: event.getSender() || "",
        createdAt: event.getTs(),
        matrixRoomId: roomId,
        referenceEventId: ""
    };
};
